appSocial.component('leaderCardExpand', {
    templateUrl: 'widgets/leaders-feed/components/leader-card-expand/LeaderCardExpandComponent.html',
    bindings: {
        trader: '<'
    },
    controller: class LeaderCardExpandComponent {
        constructor($state,
                    $scope,
                    SocialLocaleService,
                    SocialAPIService,
                    SocialUtils,
                    SocialThemeService,
                    moment) {

            this.translation = SocialLocaleService.translation;

            this.utils = SocialUtils;
            this.moment = moment;

            /**
             * @type {SocialAPIService}
             */
            this.api = SocialAPIService;

            /**
             * @type {SocialThemeService}
             */
            this.themeService = SocialThemeService;


            this.currentInvestedCapital = 0;
            this.investedCapitalChartOptions = null;
            this.profitabilityChartOptions = null;
        }

        $onInit() {
            this.update()
            this.profitabilityChartOptions = this.createPieChart([]);
        }

        $onChanges(changes) {
            //console.log('trader changes', this.trader)
        }

        $onDestroy() {
        }

        toggleCard(trader) {
            trader.expanded = !trader.expanded;
        }

        getDailyData() {
            const request = {
                _url: '/' + this.trader.id,
                from: this.moment(Date.now()).utc(true).startOf('year').unix(),
                to: this.moment().utc(true).unix(),
            };
            return this.api.request.getDailyData(request)
                .then((response) => response.data);
        }

        getTradesByMarkets() {
            return this.api.request.getTradesByMarkets('/' + this.trader.id);
        }

        update() {
            return Promise.all([
                this.getDailyData()
            ])
                .then(([dailyResponse]) => {
                    const investedCapitalData = dailyResponse.map((item) => item.invested_capital);
                    this.investedCapitalChartOptions = this.createLineChart(
                        '',
                        // labels
                        investedCapitalData.slice(Math.max(investedCapitalData.findIndex(item => item > 0) - 1, 0), investedCapitalData.length - 1)
                    );

                    this.currentInvestedCapital = dailyResponse[dailyResponse.length - 1].invested_capital;
                })
        }

        createLineChart(type, series = []) {
            const gradient = {
                from: '#cecece',
                to: '#cecece'
            };
            let lineColor = 'gray';

            gradient.from = this.themeService.getThemeColor('leader-stats', 'gradientInvestedCapitalFrom');
            gradient.to = this.themeService.getThemeColor('leader-stats', 'gradientInvestedCapitalTo');
            lineColor = this.themeService.getThemeColor('leader-stats', 'colorInvestedCapitalLine');

            const bgGradient = new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: gradient.from
            }, {
                offset: 1,
                color: gradient.to
            }]);

            return {
                grid: {
                    top: '0%',
                    left: '0%',
                    right: '0%',
                    bottom: '8.5%',
                },
                xAxis: {
                    show: false,
                    type: 'category',
                    data: series
                },
                yAxis: {
                    show: false,
                    type: 'value'
                },
                // tooltip: {},
                series: [
                    {
                        animationDuration: 300,
                        symbolSize: 0,
                        data: series,
                        type: 'line',
                        lineStyle: {
                            color: lineColor,
                            width: 2,
                            type: 'solid'
                        },
                        areaStyle: {
                            color: bgGradient
                        },
                        /*markPoint: {
                            symbol: 'circle',
                            symbolSize: 7,
                            data: [
                                {name: '', xAxis: series.length - 1, yAxis: series[series.length - 1]}
                            ],
                            itemStyle: {
                                color: lineColor
                            }
                        }*/
                    }
                ]
            };

        }


        createPieChart() {
            const series = [
                {
                    name: 'a',
                    percentage: 100 - this.trader.profitability,
                    color: this.themeService.getThemeColor('common', 'theRed'),
                },
                {
                    name: 'b',
                    percentage: this.trader.profitability,
                    color: this.themeService.getThemeColor('common', 'theGreen'),
                },
            ]
                .map(item => ({
                    name: item.name,
                    value: item.percentage,
                    itemStyle: {
                        color: item.color,
                        borderWidth: 3,
                        borderColor: this.themeService.getThemeColor('app', 'background2')
                    }
                }));

            return {
                series: [
                    {
                        type: 'pie',
                        radius: ['90%', '65%'],
                        center: ['50%', '50%'],
                        label: {
                            show: false,
                        },
                        data: series,
                    }
                ]
            };
        }

    }
});
